
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EpbDividedLayout',
  props: {
    isLayoutDivided: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {
      baseClass: 'epb-divided-layout',
    }
  },
})
